export default class EmailVerification implements IDigitalIdentityHubModule {
  public name = "EmailVerification";

  public init(): void { /* No functionality */ }

  public ready(): void {
    // show correct screen after email is verified
    janrain.events.onCaptureSaveSuccess.addHandler(result => {
      if (result.action === "emailCode" && result.status === "success" && result.screen !== "resetPasswordRequestCode" && result.screen !== "preregCreatePasswordRequestCode") {
        const handlerId = janrain.events.onCaptureRenderComplete.addHandler(function() {
          janrain.events.onCaptureRenderComplete.removeHandler(handlerId);
          janrain.capture.ui.renderScreen("verifyEmailSuccess");
        });
      }
    });

    janrain.events.onCaptureRenderComplete.addHandler(function(result) {
      // Renders correct screen in re-verification flow if so setup in the settings
      if (result.screen === "emailVerificationRequired" && janrain.settings.capture.ignoreEmailVerificationRequiredScreen !== "false") {
        const emailVerificationRequired = document.getElementById("emailVerificationRequired");
        if (emailVerificationRequired) {
          emailVerificationRequired.style.display = "none";
        }
        if (janrain.settings.capture.prevScreenName === "signIn" || janrain.settings.capture.prevScreenName === "signInFull") {
          janrain.capture.ui.renderScreen("resendVerificationSuccess");
        }
      }
    });
  }
}
